import React from 'react';
import styled from 'styled-components';
import ServiceCard from '../components/ServiceCard'; // Reusing the card component

const CareersWrapper = styled.section`
  padding: 50px 20px;
  max-width: 1200px;
  margin: 0 auto;
`;

const CareersTitle = styled.h1`
  font-size: 2.5rem;
  margin-bottom: 40px;
  text-align: center;
  color: #002244;
`;

const JobGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 30px;
`;

const Description = styled.p`
  font-size: 1.15rem;
  color: #333;
  line-height: 1.5;
`;

const List = styled.ul`
  margin: 15px 0;
  padding-left: 20px;
  list-style-type: disc;
`;

const ListItem = styled.li`
  margin-bottom: 10px;
  font-size: 1rem;
  color: #333;
`;

const Careers = () => (
  <CareersWrapper>
    <CareersTitle>Join Our Team</CareersTitle>
    <JobGrid>
      <ServiceCard
        title="AWS Solutions Architect - Casual Role"
        description={
          <>
            <Description>
              As an AWS Solutions Architect, you will be responsible for designing scalable and secure cloud-based solutions using AWS services. You will collaborate with clients and cross-functional teams to gather requirements, define architecture, and ensure successful cloud implementations.
            </Description>
            <br></br>
            <strong>Responsibilities:</strong>
            <List>
              <ListItem>Design and deploy scalable, highly available, and fault-tolerant systems on AWS.</ListItem>
              <ListItem>Migrate complex, multi-tier applications on AWS.</ListItem>
              <ListItem>Provide expertise across compute, storage, networking, and security services.</ListItem>
              <ListItem>Recommend AWS best practices for architecture, security, and cost optimization.</ListItem>
            </List>
            <strong>Requirements:</strong>
            <List>
              <ListItem>Proven experience as an AWS Solutions Architect, preferably with AWS certification.</ListItem>
              <ListItem>Experience with architecture and cloud migration strategies.</ListItem>
              <ListItem>Proficiency in Infrastructure as Code (IaC) tools such as CloudFormation or Terraform.</ListItem>
            </List>
          </>
        }
      />

      <ServiceCard
        title="AWS Developer - Casual Role"
        description={
          <>
            <Description>
              We are looking for an AWS Developer to develop and maintain applications on AWS. This role involves working closely with architects and other developers to deliver highly available and secure solutions.
            </Description>
            <br></br>
            <strong>Responsibilities:</strong>
            <List>
              <ListItem>Develop cloud-native applications using AWS services like Lambda, API Gateway, and DynamoDB.</ListItem>
              <ListItem>Automate deployment pipelines using CI/CD tools like CodePipeline and CodeBuild.</ListItem>
              <ListItem>Collaborate with cross-functional teams to integrate AWS services within applications.</ListItem>
              <ListItem>Write maintainable and performant code.</ListItem>
            </List>
            <strong>Requirements:</strong>
            <List>
              <ListItem>Experience developing applications on AWS using services such as Lambda, EC2, and S3.</ListItem>
              <ListItem>Proficiency in programming languages such as Python, Java, or Node.js.</ListItem>
              <ListItem>Familiarity with serverless architecture and microservices.</ListItem>
            </List>
          </>
        }
      />
    </JobGrid>
  </CareersWrapper>
);

export default Careers;
